module.exports = __webpack_public_path__ + "static/media/000002.45ddb121.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000002.mp3
// module id = 825
// module chunks = 0